import { useTranslation } from '@conekta/cronos/i18n';
import { Link } from 'app/components/Link';
import { CheckoutFrameContext } from 'app/context';
import CancelButton from 'app/features/plugins/components/CancelButton';
import { ChangeLanguage } from 'app/pages/hosted-checkout/components/ChangeLanguage';
import Logo from 'app/pages/hosted-checkout/components/Logo';
import OrderDetail from 'app/pages/hosted-checkout/components/OrderDetail';
import { SidebarWrapper } from 'app/pages/hosted-checkout/components/SidebarWrapper';
import { sendAnalytic } from 'app/util/analytics';
import { AnalyticEvents } from 'app/util/constants';
import { useContext, type PropsWithChildren } from 'react';

interface ShoppingCartProps {
  customStyleJSON: any;
  isDesktop?: boolean;
}

export const ShoppingCart = ({ customStyleJSON, isDesktop }: ShoppingCartProps) => {
  const { t } = useTranslation();
  const checkoutFooterText = t('hostedCheckout.common.helpCenter');
  const {
    checkoutRequest,
    entity: { name: merchantName },
  } = useContext(CheckoutFrameContext);
  const { id, companyId, type, amount, name, orderTemplate } = checkoutRequest;
  const hasSubscription = !!checkoutRequest?.plans;

  const { sidebar: sidebarStyles } = customStyleJSON;
  const sendAnalyticHelpCenter = () => {
    sendAnalytic(AnalyticEvents.helpCenter, id, companyId, type);
  };
  return (
    <SidebarWrapper {...sidebarStyles} className='main-wrapper__Checkout'>
      {isDesktop && <CancelButton />}
      <OrderDetail name={name} amount={amount} orderTemplate={orderTemplate} hasSubscription={hasSubscription}>
        <Logo theme={customStyleJSON?.styles} merchantName={merchantName} />
      </OrderDetail>
      <CheckoutFooter
        sidebarStyles={sidebarStyles}
        sendAnalyticHelpCenter={sendAnalyticHelpCenter}
        text={checkoutFooterText}
      >
        <ChangeLanguage id={id} companyId={companyId} type={type} />
      </CheckoutFooter>
    </SidebarWrapper>
  );
};

interface CheckoutFooterProps {
  sidebarStyles: any;
  sendAnalyticHelpCenter: () => void;
  text: string;
}

const CheckoutFooter = ({
  sidebarStyles,
  sendAnalyticHelpCenter,
  text,
  children,
}: PropsWithChildren<CheckoutFooterProps>) => (
  <div className='checkout-footer'>
    <Link
      {...sidebarStyles}
      href='https://help.conekta.com/hc/es-419/sections/360007368253-Link-de-Pago'
      target='_blank'
      rel='noreferrer'
      onClick={sendAnalyticHelpCenter}
    >
      {text}
    </Link>
    <span className='checkout-footer__separator'>|</span>
    {children}
  </div>
);
